import {getRuntimeConfig} from "../runtimeConfig.ts";

export type SelfServiceTeamsPrincipal = {
    tenantId?: string;
    userId?: string;
};

function applyPrincipalParams(params: URLSearchParams, principal?: SelfServiceTeamsPrincipal) {
    if (principal?.tenantId) {
        params.set("tenant_id", principal.tenantId);
    }
    if (principal?.userId) {
        params.set("user_id", principal.userId);
    }
}

export function buildSelfServiceLoginUrl(principal?: SelfServiceTeamsPrincipal): string {
    const params = new URLSearchParams({
        provider: "teams",
    });
    applyPrincipalParams(params, principal);
    return `${getRuntimeConfig().selfServiceBaseUrl}/api/auth/start?${params.toString()}`;
}

export function buildSelfServiceSeriesUrl(principal?: SelfServiceTeamsPrincipal): string {
    const params = new URLSearchParams({
        provider: "teams",
        next: "/series",
    });
    applyPrincipalParams(params, principal);
    return `${getRuntimeConfig().selfServiceBaseUrl}/api/auth/start?${params.toString()}`;
}
